import { render } from "./SeTab.vue?vue&type=template&id=60288116&scoped=true&ts=true"
import script from "./SeTab.vue?vue&type=script&lang=ts"
export * from "./SeTab.vue?vue&type=script&lang=ts"

import "./SeTab.vue?vue&type=style&index=0&id=60288116&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60288116"]])

export default __exports__